export const watchlistPublicationStatusValues = [
  "draft",
  "inReview",
  "published",
  "archived"
];

const watchlistPublicationStatuses = new Set(
  watchlistPublicationStatusValues
);

export const normalizeWatchlistPublicationStatus = (
  publicationStatus,
  isPublished = false,
  fallback = "draft"
) => {
  const requestedStatus = String(publicationStatus ?? "").trim();

  if (watchlistPublicationStatuses.has(requestedStatus)) {
    return requestedStatus;
  }

  if (isPublished === true) {
    return "published";
  }

  return watchlistPublicationStatuses.has(fallback) ? fallback : "draft";
};

export const isPublishedWatchlistStatus = publicationStatus =>
  publicationStatus === "published";
